import { ApiAmount } from "shared/types/ApiAmount";
import { ApiRegistrationParticipantForParticipantResponse } from "shared/types/ApiRegistrationParticipantForParticipantResponse";
import ApiRegistrationFormForTicketUpgrade from "shared/types/ApiRegistrationFormForTicketUpgrade";

export function getApplicableAmount(props: {
  regParticipantFormDetails: ApiRegistrationParticipantForParticipantResponse;
  ticketUpgradeFormDetails: ApiRegistrationFormForTicketUpgrade;
  applicablePrice?: ApiAmount;
}): ApiAmount | undefined {
  return (
    props.regParticipantFormDetails.regPurchaseOrder?.amount ||
    props.applicablePrice ||
    props.ticketUpgradeFormDetails.priceDifference
  );
}
